 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientGeneral',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		var $jForm,
		    $email = $('#clientgeneral-email');

		if (response.data.response_code === "duplicate_email") {

			Adzuki.CustomConfirm({
				body   : response.data.message,
				confirm: function yes() {
					$jForm = $('form[name="' + form.name + '"]');

					$('#clientgeneral-alternate_email').val($email.val());
					$email.val('');

					// set hidden input indicating that the user wants to ignore the dupe email, so we do not throw a confirm again
					$jForm.find('.dupe_emails_proceed').val(1);
					$jForm.submit();
				}
			});
		}
	};

}(jQuery, window.Adzuki || {}));
